<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290" overlay-opacity="0.8">
      <v-card v-if="!loading" :style="{ 'background-color': welcomeBGColor }" style="margin:0px; padding:0px">
        <v-card-text style="padding: 0;">
          <v-btn
                  v-show="!hidden"
                  :color="welcomeBGColor"
                  @click="onClose"
                  fab
                  dark
                  x-small
                  absolute
                  top
                  right
                  style="top: 6px;right:8px;"
                  elevation="0"
                >
                  <v-icon
                    :style="{ 'color': welcomeColor }"
                  >
                  mdi-close</v-icon>
                </v-btn>
          <center>
            <v-img 
              v-if="image"
              :src="image" :lazy-src="image" 
                  @click="dialog = false"
              />
          </center>
          <center style="margin-bottom: 20px;" v-if="icon && icon.length > 0 && icon !== '6'">
            <button 
              disabled="true"
              style="border-radius:50%; height:55px; width:55px; text-align:center; padding:5px 5px 10px 5px; opacity:0.7;"
              :style="{ 'background-color': welcomeColor}"
            >
              <v-icon
                style="margin-left: 0px; color: white;font-size:35px;"
                dark
                class="activity-button"
                :style="{ 'color': welcomeBGColor}"
              >
                {{icon}}
              </v-icon>
            </button>
          </center>
          <div style="padding: 10px" class="result-html">
            <vue-editor 
              v-model="messageLocale"
              :disabled="true"
              :editor-toolbar="aux"
              :style="{ 'color': `${welcomeColor} !important`, 'font-size': `500px !important` }"
            />
          </div>
          <count-down v-if="countDown" :countDown="countDown" :bgcolor="welcomeBGColor" />
          <div
              v-if="withButton"
              style="padding: 20px;"
            >
            <v-btn 
              block
              :color="welcomeColor"
              @click="handleOpenButtonwindow"
            >
            <span :style="{ color: welcomeBGColor  }">
              {{buttonText}}
            </span>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { VueEditor } from "vue2-editor"
  import utils from '@/services/utils'
  import CountDown from './CountDown'
  export default {
    components: {
      VueEditor,
      CountDown
    },
    props: {
      data: {
        type: Object,
        required: true
      },
      locale: {
        type: String,
        required: true,
      },
      onClose: {
        type: Function,
        required: true,
      },
      config: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        hidden: null,
        dialog: false,
        loading: true,
        icon: this.data.Icon,
        message: null,
        messageLocale: null,
        welcomeBGColor: null,
        welcomeColor: null,
        aux: [[],[],[],[],[],[],[],[],[],[],[],[],[{  }],[]],
        countDown: null,
        withButton: false,
        buttonText: null,
        buttonLink: null,
      }
    },
    computed: {
      btnBackgroundColor () {        
        return this.config.BtnBackgroundColor && this.config.BtnBackgroundColor !== '' ? this.config.BtnBackgroundColor : this.config.BGColor
      },
      btnTextColor () {
        return this.config.BtnTextColor && this.config.BtnTextColor !== '' ? this.config.BtnTextColor : 'white'
      },
      foodDrinkTextColor () {
        return this.config.FoodDrinkTextColor && this.config.FoodDrinkTextColor !== '' ? this.config.FoodDrinkTextColor : this.config.ColorContent
      },
    },
    watch: {
      data () {
        this.prepareData()
      },
      locale () {
        this.prepareData()
      },
    },
    mounted () {
      this.prepareData()
    },
    methods: {
      prepareData () {
        if (!this.data) {
          this.dialog = false
          return
        }
        this.loading = true
        this.icon = this.data.Icon
        this.message = this.data.Message
        this.messageLocale = utils.getTranslation(this.data.Message, this.locale)
        this.welcomeBGColor = this.data.BGColor
        this.welcomeColor = this.data.Color
        this.image = this.data.Image
        this.countDown = this.data.IsCountDown && this.data.CountDown ? this.data.CountDown : null
        this.withButton = this.data.WithButton
        this.buttonText = utils.getTranslation(this.data.ButtonText, this.locale)
        this.buttonLink = utils.getTranslation(this.data.ButtonLink, this.locale)
        this.dialog = true
        this.loading = false
      },
      handleOpenButtonwindow () {
        window.location = this.buttonLink
        this.onClose()
      }
    }
  }
</script>

<style scoped>
  .modal-allergens {
    background-color: rgba(241, 241, 241);
  }
  .ql-editor p {
    font-size: var(--FontSizeContent);
  }
  .result-html .ql-toolbar.ql-snow {
    height: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .result-html .ql-container.ql-snow {
    border: 0px !important;
  }
  .result-html .ql-editor {
    min-height: 0px !important;
  }   
</style>


